export default function AuraMark({ size = 32, className = "" }) {
  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <span
        className="aura-mark absolute inset-0 rounded-full"
        style={{ animation: "spin 22s linear infinite" }}
      />
      <span
        className="absolute inset-[3px] rounded-full"
        style={{ background: "var(--aura-ivory)" }}
      />
      <span
        className="absolute inset-[8px] rounded-full"
        style={{ background: "var(--aura-teal)" }}
      />
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </span>
  );
}
